import { takeEvery } from 'redux-saga'
import { call, put, select } from 'redux-saga/effects'
import fetcher from 'modules/fetcher'
import { updateCurrentUser, updateAccount } from 'ducks'
import { getCurrentUserSelector, getCurrentAccountSelector } from 'selectors'
import { getVisibleFields, getAdminVisibleFields } from 'Profiles/selectors'

import {
  SAVE_DETAILS_FIELD_ORDER_SUBMIT,
  RESET_DETAILS_FIELDS_TO_DEFAULT_SUBMIT,
  SAVE_ADMIN_DETAILS_FIELD_ORDER_SUBMIT,
  RESET_ADMIN_DETAILS_FIELDS_TO_DEFAULT_SUBMIT
} from 'Profiles/constants/detailsFields'

import { fieldMap } from 'Profiles/Draggable/hooks/useProfileDetailsFieldConfiguration'

export function * saveDetailsFieldOrderSaga ({ payload }) {
  const { profileType } = payload
  const fields = yield select(state => getVisibleFields(state, profileType))

  try {
    yield call(fetcher, `/api/v3/profile_details_fields/${profileType}`, {
      method: 'PUT',
      body: JSON.stringify({ fields }),
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })

    const currentUser = yield select(getCurrentUserSelector)
    yield put(updateCurrentUser({
      ...currentUser,
      [fieldMap[profileType]]: fields
    }))
  } catch (error) {
    console.error('Failed to save user profile details fields:', error)
  }
}

export function * saveAdminDetailsFieldOrderSaga ({ payload }) {
  const { profileType } = payload
  const fields = yield select(state => getAdminVisibleFields(state, profileType))
  const settingKey = fieldMap[profileType]

  try {
    yield call(fetcher, `/api/v3/admin/account_settings/${settingKey}`, {
      method: 'PUT',
      body: JSON.stringify({ key: settingKey, value: fields }),
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })

    const currentAccount = yield select(getCurrentAccountSelector)
    yield put(updateAccount({
      ...currentAccount,
      [settingKey]: fields
    }))
  } catch (error) {
    console.error('Failed to save admin profile details fields:', error)
  }
}

export function * resetDetailsFieldsToDefaultSaga ({ payload }) {
  const { profileType } = payload

  try {
    yield call(fetcher, `/api/v3/profile_details_fields/${profileType}`, {
      method: 'DELETE',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })

    const currentUser = yield select(getCurrentUserSelector)
    yield put(updateCurrentUser({
      ...currentUser,
      [fieldMap[profileType]]: null
    }))
  } catch (error) {
    console.error('Failed to reset user profile details fields:', error)
  }
}

export function * resetAdminDetailsFieldsToDefaultSaga ({ payload }) {
  const { profileType } = payload
  const settingKey = fieldMap[profileType]

  try {
    yield call(fetcher, `/api/v3/admin/account_settings/${settingKey}`, {
      method: 'PUT',
      body: JSON.stringify({ key: settingKey, value: null }),
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })

    const currentAccount = yield select(getCurrentAccountSelector)
    yield put(updateAccount({
      ...currentAccount,
      [settingKey]: null
    }))
  } catch (error) {
    console.error('Failed to reset admin profile details fields:', error)
  }
}

export function * watchSaveDetailsFieldOrderSaga () {
  yield call(takeEvery, SAVE_DETAILS_FIELD_ORDER_SUBMIT, saveDetailsFieldOrderSaga)
}

export function * watchResetDetailsFieldsToDefaultSaga () {
  yield call(takeEvery, RESET_DETAILS_FIELDS_TO_DEFAULT_SUBMIT, resetDetailsFieldsToDefaultSaga)
}

export function * watchSaveAdminDetailsFieldOrderSaga () {
  yield call(takeEvery, SAVE_ADMIN_DETAILS_FIELD_ORDER_SUBMIT, saveAdminDetailsFieldOrderSaga)
}

export function * watchResetAdminDetailsFieldsToDefaultSaga () {
  yield call(takeEvery, RESET_ADMIN_DETAILS_FIELDS_TO_DEFAULT_SUBMIT, resetAdminDetailsFieldsToDefaultSaga)
}
